import { useState } from "react";
import { useSelector } from "react-redux";
import SubmmisionsTable from "./SubmmisionsTable"
import SubmmisionsChart from "./SubmmisionsChart";
import { SourceTypeTextEnum } from "../../../../../../models/SourceTypeEnum";
import classes from "./SubmmisionsList.module.css"

const SubmmisionsList = ({ currentAssessment, submissions, title, setSubmissionScore, handeleShowLesson, assessments }) => {
    const { texts, direction } = useSelector((state) => state.translate);
    const PreviewTypeEnum = {
        table: 1,
        chart: 2
    }
    const [submmisionsPreviewType, setSubmmisionsPreviewType] = useState(PreviewTypeEnum.table)

    return (
        <div className={`${classes[direction]} ${classes.SubmmisionsList}`} >
            <div className={`${classes[direction]} ${classes.SubmmisionsListDirection}`}>
                <div className={classes.TitleIconsContainer}>
                    <div className={classes.Title}>
                        <div className={classes.SlideName}>
                            <span>{title?.parentName}</span>
                            {currentAssessment?.sourceType == SourceTypeTextEnum.SLCQuestionnaire && <span className={classes.PreviewQuestion} onClick={() => handeleShowLesson()} >{texts.previewQuestion} </span>}
                        </div>
                        <div>{title?.name} </div>
                    </div>
                    <div className={classes.Icons}>
                        <div className={`${classes.TableIcon} ${submmisionsPreviewType == PreviewTypeEnum.chart && classes.GrayIcon} `} onClick={() => setSubmmisionsPreviewType(PreviewTypeEnum.table)}></div>
                        <div className={`${classes.ChartIcon} ${submmisionsPreviewType == PreviewTypeEnum.table && classes.GrayIcon} `} onClick={() => setSubmmisionsPreviewType(PreviewTypeEnum.chart)}></div>
                    </div>
                </div>
                {
                    submmisionsPreviewType == PreviewTypeEnum.table ?
                        <SubmmisionsTable
                            currentAssessment={currentAssessment}
                            submissions={submissions}
                            setSubmissionScore={setSubmissionScore}
                            assessments={assessments}
                        /> :
                        <SubmmisionsChart
                            currentAssessment={currentAssessment}
                            submissions={submissions}
                        ></SubmmisionsChart>
                }
            </div>
        </div>
    )
}
export default SubmmisionsList